import React, {Component} from 'react';
import {
    Button, Card, CardBody, CardHeader, Col, Form, FormGroup, Input, Label, Modal, ModalBody, ModalHeader,
    Row
} from 'reactstrap';
import 'react-bootstrap-table/dist//react-bootstrap-table-all.min.css';
import 'spinkit/css/spinkit.css';
import {Redirect} from "react-router-dom";
import {ToastContainer, toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Widget from "../../components/Widget/Widget";
import companyService from "../../services/companyService";
import contactService from "../../services/contactService";
import Select from 'react-select';
import AsyncSelect from 'react-select/lib/Async';

const countries = require("i18n-iso-countries");
countries.registerLocale(require("i18n-iso-countries/langs/de.json"))

class AddCompany extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            success: false,
            ceo: '',
            name: '',
            company_type: '',
            registration_number: '',
            note: '',
            address: '',
            address_number: '',
            city: '',
            zip: '',
            country: '',
            email: '',
            phone_number: '',
            cell_number: '',
            fax_number: '',
            linkedin: '',
            facebook: '',
            twitter: '',
            website: '',
            iban: '',
            bank: '',
            vat_reg_no: '',
            invoice_email: '',
        };

        this.typingTimer = null;
        this.typingInterval = 600;

        this.handleChange = this.handleChange.bind(this);
        this.saveChanges = this.saveChanges.bind(this);
        this.success = this.success.bind(this);
        this.unsuccessful = this.unsuccessful.bind(this);
        this.loadContacts = this.loadContacts.bind(this);
        this.onContactClick = this.onContactClick.bind(this);
        this.addNewCompany = this.addNewCompany.bind(this);
    }

    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    saveChanges(ceo) {
        this.setState({
            ceo: ceo
        });
    }

    selectCountry = (country) => {
        this.setState({
            country: country.value
        });
    };

    countryList() {
        let options = [];
        let countryList = countries.getNames("de");

        Object.entries(countryList).forEach(([key, val]) => { options.push({value: key, label: val})});

        this.setState({
            options: options
        })
    }

    loadContacts(value) {
        return new Promise(resolve => {
            clearTimeout(this.typingTimer);

            this.typingTimer = setTimeout(() => {
                contactService.getContacts(1, value)
                    .then(response => {
                        resolve({
                            options: response.data.results.map(contact => {
                                return {value: contact.id, label: contact.first_name + " " + contact.last_name}
                            })
                        })
                    })
                    .catch(err => {
                        console.log(err)
                    })

            }, this.typingInterval)

        })
    }

    onContactClick(contact) {
        this.props.history.push("/contacts/" + contact.value);
    }

    success() {
        return toast.success('Erfolgreich!');
    }

    unsuccessful(msg='Erfolglos!') {
        return toast.error(msg)
    }

    addNewCompany() {

        companyService.addCompany({
            ceo: this.state.ceo ? this.state.ceo.value : null,
            name: this.state.name,
            company_type: this.state.company_type,
            registration_number: this.state.registration_number,
            note: this.state.note,
            address: this.state.address,
            address_number: this.state.address_number,
            city: this.state.city,
            zip: this.state.zip,
            country: this.state.country,
            email: this.state.email,
            phone_number: this.state.phone_number,
            cell_number: this.state.cell_number,
            fax_number: this.state.fax_number,
            linkedin: this.state.linkedin,
            facebook: this.state.facebook,
            twitter: this.state.twitter,
            website: this.state.website,
            iban: !this.state.iban ? null : this.state.iban,
            bank: this.state.bank,
            vat_reg_no: this.state.vat_reg_no,
            invoice_email: this.state.invoice_email,
        })
            .then((response) => {
                if (response.status) {
                    this.setState({
                        success: !this.state.success
                    })
                }
            })
            .catch((error) => {
                let errors = error.response.data.error;

                Object.entries(errors).map((error) => {
                    return this.unsuccessful(error[0] + ": " + error[1][0]);
                })
            });

    };

    componentDidMount() {
        document.title = "PAYUCA | Firma hinzufügen";
        this.countryList()
    }


    render() {

        if(this.state.success) {
            return <Redirect to="/companies"/>
        }

        if (this.state.loading) {
            return (<div className="sk-rotating-plane"/>);
        }

        const containerStyle = {
            zIndex: 1999
        };

        return (
            <div className="animated fadeIn">
                <ToastContainer position="bottom-right" autoClose={5000} style={containerStyle}/>
                <Row>
                    <Col xs="12" sm="12" lg="10">
                        <Widget icon="icon-globe" color="info" header="Firma hinzufügen" />
                    </Col>
                    <Col xs="12" sm="12" lg="2">
                        <Widget
                            icon="icon-plus"
                            color="success"
                            header="Speichern"
                            invert
                            style={{cursor: this.state.name.length < 2 ? "not-allowed" : "pointer"}}
                            onClick={this.state.name.length < 2 ? null : this.addNewCompany}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col xs="12" sm="12" lg="12">
                        <Card>
                            <CardHeader>
                                Firma hinzufügen
                            </CardHeader>
                            <CardBody>
                                <Form action="" method="post" encType="multipart/form-data" className="form-horizontal">
                                    <Row>
                                        <Col xs="12" sm="12" md="6">
                                            <FormGroup row>
                                                <Col md="3">
                                                    <Label htmlFor="selectSm">Firmenname *</Label>
                                                </Col>
                                                <Col xs="12" md="9">
                                                    <Input type="text" className="name" name="name" id="name" value={this.state.name} onChange={this.handleChange} />
                                                </Col>
                                            </FormGroup>
                                            <FormGroup row>
                                                <Col md="3">
                                                    <Label htmlFor="company_type">Gesellschaftstyp</Label>
                                                </Col>
                                                <Col xs="12" md="9">
                                                    <Input type="text" name="company_type" id="company_type" value={this.state.company_type} onChange={this.handleChange} />
                                                </Col>
                                            </FormGroup>
                                            <FormGroup row>
                                                <Col md="3">
                                                    <Label htmlFor="registration_number">Firmenbuchnummer</Label>
                                                </Col>
                                                <Col xs="12" md="9">
                                                    <Input type="text" name="registration_number" id="registration_number" value={this.state.registration_number} onChange={this.handleChange} />
                                                </Col>
                                            </FormGroup>
                                            <FormGroup row>
                                                <Col md="3">
                                                    <Label htmlFor="vat_reg_no">UID</Label>
                                                </Col>
                                                <Col xs="12" md="9">
                                                    <Input type="text" name="vat_reg_no" id="vat_reg_no" value={this.state.vat_reg_no} onChange={this.handleChange} />
                                                </Col>
                                            </FormGroup>
                                            <FormGroup row>
                                                <Col md="3">
                                                    <Label htmlFor="vat_reg_no">Rechnungs-E-Mail</Label>
                                                </Col>
                                                <Col xs="12" md="9">
                                                    <Input type="text" name="invoice_email" id="invoice_email" value={this.state.invoice_email} onChange={this.handleChange} />
                                                </Col>
                                            </FormGroup>
                                            <FormGroup row>
                                                <Col md="3">
                                                    <Label htmlFor="ceo">Geschäftsführer</Label>
                                                </Col>
                                                <Col xs="12" md="9">
                                                    <AsyncSelect
                                                        name="ceo"
                                                        value={!this.state.ceo ? null : this.state.ceo}
                                                        loadOptions={this.loadContacts}
                                                        onChange={this.saveChanges}
                                                        onValueClick={this.onContactClick}
                                                    />
                                                </Col>
                                            </FormGroup>
                                            <FormGroup row>
                                                <Col md="3">
                                                    <Label htmlFor="address">Straße</Label>
                                                </Col>
                                                <Col xs="12" md="9">
                                                    <Input type="text" name="address" id="address" value={this.state.address} onChange={this.handleChange} />
                                                </Col>
                                            </FormGroup>
                                            <FormGroup row>
                                                <Col md="3">
                                                    <Label htmlFor="address_number">Hausnummer</Label>
                                                </Col>
                                                <Col xs="12" md="9">
                                                    <Input type="text" name="address_number" id="address_number" value={this.state.address_number} onChange={this.handleChange} />
                                                </Col>
                                            </FormGroup>
                                            <FormGroup row>
                                                <Col md="3">
                                                    <Label htmlFor="zip">Postleitzahl</Label>
                                                </Col>
                                                <Col xs="12" md="9">
                                                    <Input type="text" name="zip" id="zip" value={this.state.zip} onChange={this.handleChange} />
                                                </Col>
                                            </FormGroup>
                                            <FormGroup row>
                                                <Col md="3">
                                                    <Label htmlFor="city">Stadt</Label>
                                                </Col>
                                                <Col xs="12" md="9">
                                                    <Input type="text" name="city" id="city" value={this.state.city} onChange={this.handleChange} />
                                                </Col>
                                            </FormGroup>
                                            <FormGroup row>
                                                <Col md="3">
                                                    <Label htmlFor="country">Land</Label>
                                                </Col>
                                                <Col xs="12" md="9">
                                                    <Select
                                                        value={this.state.country}
                                                        onChange={this.selectCountry}
                                                        options={this.state.options}
                                                    />
                                                </Col>
                                            </FormGroup>
                                        </Col>
                                        <Col xs="12" sm="12" md="6">
                                            <FormGroup row>
                                                <Col md="3">
                                                    <Label htmlFor="phone_number">Telefon</Label>
                                                </Col>
                                                <Col xs="12" md="9">
                                                    <Input type="text" name="phone_number" id="phone_number" value={this.state.phone_number} onChange={this.handleChange} />
                                                </Col>
                                            </FormGroup>
                                            <FormGroup row>
                                                <Col md="3">
                                                    <Label htmlFor="cell_number">Mobiltelefon</Label>
                                                </Col>
                                                <Col xs="12" md="9">
                                                    <Input type="text" name="cell_number" id="cell_number" value={this.state.cell_number} onChange={this.handleChange} />
                                                </Col>
                                            </FormGroup>
                                            <FormGroup row>
                                                <Col md="3">
                                                    <Label htmlFor="fax_number">Fax</Label>
                                                </Col>
                                                <Col xs="12" md="9">
                                                    <Input type="text" name="fax_number" id="fax_number" value={this.state.fax_number} onChange={this.handleChange} />
                                                </Col>
                                            </FormGroup>
                                            <FormGroup row>
                                                <Col md="3">
                                                    <Label htmlFor="email">E-Mail-Adresse</Label>
                                                </Col>
                                                <Col xs="12" md="9">
                                                    <Input type="text" name="email" id="email" value={this.state.email} onChange={this.handleChange} />
                                                </Col>
                                            </FormGroup>
                                            <FormGroup row>
                                                <Col md="3">
                                                    <Label htmlFor="website">Website</Label>
                                                </Col>
                                                <Col xs="12" md="9">
                                                    <Input type="text" name="website" id="website" value={this.state.website} onChange={this.handleChange} />
                                                </Col>
                                            </FormGroup>
                                            <FormGroup row>
                                                <Col md="3">
                                                    <Label htmlFor="linkedin">Linkedin</Label>
                                                </Col>
                                                <Col xs="12" md="9">
                                                    <Input type="text" name="linkedin" id="linkedin" value={this.state.linkedin} onChange={this.handleChange} />
                                                </Col>
                                            </FormGroup>
                                            <FormGroup row>
                                                <Col md="3">
                                                    <Label htmlFor="facebook">Facebook</Label>
                                                </Col>
                                                <Col xs="12" md="9">
                                                    <Input type="text" name="facebook" id="facebook" value={this.state.facebook} onChange={this.handleChange} />
                                                </Col>
                                            </FormGroup>
                                            <FormGroup row>
                                                <Col md="3">
                                                    <Label htmlFor="twitter">Twitter</Label>
                                                </Col>
                                                <Col xs="12" md="9">
                                                    <Input type="text" name="twitter" id="twitter" value={this.state.twitter} onChange={this.handleChange} />
                                                </Col>
                                            </FormGroup>
                                            <FormGroup row>
                                                <Col md="3">
                                                    <Label htmlFor="bank">Bank</Label>
                                                </Col>
                                                <Col xs="12" md="9">
                                                    <Input type="text" name="bank" id="bank" value={this.state.bank} onChange={this.handleChange} />
                                                </Col>
                                            </FormGroup>
                                            <FormGroup row>
                                                <Col md="3">
                                                    <Label htmlFor="iban">IBAN</Label>
                                                </Col>
                                                <Col xs="12" md="9">
                                                    <Input type="text" name="iban" id="iban" value={this.state.iban} onChange={this.handleChange} />
                                                </Col>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </Form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default AddCompany;
